import vm from "@/main";
import axios from "axios";

const _guardCallback = arg => {
  if (typeof arg === "function") {
    arg();
  }
};

const _onError = error => {
  if (error.response) {
    if (error.response.data.errors) {
      if (Array.isArray(error.response.data.errors)) {
        for (
          let index = 0;
          index < error.response.data.errors.length;
          index++
        ) {
          vm.$notification.error(error.response.data.errors[index], {
            title: "Error"
          });
        }
      } else {
        for (var prop in error.response.data.errors) {
          if (!error.response.data.errors.hasOwnProperty(prop)) {
            continue;
          }
          vm.$notification.error(error.response.data.errors[prop][0], {
            title: "Error"
          });
        }
      }
    } else {
      vm.$notification.error(
        `Request failed with status code ${error.response.status}`,
        { title: "Error" }
      );
    }
  } else if (error.request) {
    vm.$notification.error("Something wrong with request messages.", {
      title: "Error"
    });
  } else {
    vm.$notification.error("Something went wrong, please try again later.", {
      title: "Error"
    });
  }

  return {
    isSuccess: false
  };
};

const syncApi = {
  get: (url, onBeginCallback, onFinallyCallback) => {
    _guardCallback(onBeginCallback);

    return axios
      .get(url)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return _onError(error);
      })
      .finally(() => {
        _guardCallback(onFinallyCallback);
      });
  },
  post: (url, payload, onBeginCallback, onFinallyCallback) => {
    _guardCallback(onBeginCallback);

    return axios
      .post(url, payload)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return _onError(error);
      })
      .finally(() => {
        _guardCallback(onFinallyCallback);
      });
  },
  put: (url, payload, onBeginCallback, onFinallyCallback) => {
    _guardCallback(onBeginCallback);

    return axios
      .put(url, payload)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return _onError(error);
      })
      .finally(() => {
        _guardCallback(onFinallyCallback);
      });
  },
  delete: (url, onBeginCallback, onFinallyCallback) => {
    _guardCallback(onBeginCallback);

    return axios
      .delete(url)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return _onError(error);
      })
      .finally(() => {
        _guardCallback(onFinallyCallback);
      });
  },
  getWithOptions: (url, option, onBeginCallback, onFinallyCallback) => {
    _guardCallback(onBeginCallback);

    return axios
      .get(url, option)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return _onError(error);
      })
      .finally(() => {
        _guardCallback(onFinallyCallback);
      });
  },
  postWithOptions: (
    url,
    option,
    payload,
    onBeginCallback,
    onFinallyCallback
  ) => {
    _guardCallback(onBeginCallback);

    return axios
      .post(url, payload, option)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return _onError(error);
      })
      .finally(() => {
        _guardCallback(onFinallyCallback);
      });
  },
  putWithOptions: (
    url,
    option,
    payload,
    onBeginCallback,
    onFinallyCallback
  ) => {
    _guardCallback(onBeginCallback);

    return axios
      .put(url, payload, option)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return _onError(error);
      })
      .finally(() => {
        _guardCallback(onFinallyCallback);
      });
  }
};

const asyncApi = {
  get: async (url, onBeginCallback, onFinallyCallback) => {
    try {
      _guardCallback(onBeginCallback);
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      return _onError(error);
    } finally {
      _guardCallback(onFinallyCallback);
    }
  },
  post: async (
    url,
    payload,
    onBeginCallback,
    onFinallyCallback,
    onErrorCallback
  ) => {
    try {
      _guardCallback(onBeginCallback);
      const response = await axios.post(url, payload);
      return response.data;
    } catch (error) {
      if (typeof onErrorCallback === "function") {
        return onErrorCallback(error.response.data);
      }
      return _onError(error);
    } finally {
      _guardCallback(onFinallyCallback);
    }
  },
  put: async (
    url,
    payload,
    onBeginCallback,
    onFinallyCallback,
    onErrorCallback
  ) => {
    try {
      _guardCallback(onBeginCallback);
      const response = await axios.put(url, payload);
      return response.data;
    } catch (error) {
      if (typeof onErrorCallback === "function") {
        return onErrorCallback(error.response.data);
      }
      return _onError(error);
    } finally {
      _guardCallback(onFinallyCallback);
    }
  },
  delete: async (url, onBeginCallback, onFinallyCallback) => {
    try {
      _guardCallback(onBeginCallback);
      const response = await axios.delete(url);
      return response.data;
    } catch (error) {
      return _onError(error);
    } finally {
      _guardCallback(onFinallyCallback);
    }
  },
  getWithOptions: async (url, option, onBeginCallback, onFinallyCallback) => {
    try {
      _guardCallback(onBeginCallback);
      const response = await axios.get(url, option);
      return response.data;
    } catch (error) {
      return _onError(error);
    } finally {
      _guardCallback(onFinallyCallback);
    }
  },
  postWithOptions: async (
    url,
    option,
    payload,
    onBeginCallback,
    onFinallyCallback
  ) => {
    try {
      _guardCallback(onBeginCallback);
      const response = await axios.post(url, payload, option);
      return response.data;
    } catch (error) {
      return _onError(error);
    } finally {
      _guardCallback(onFinallyCallback);
    }
  },
  putWithOptions: async (
    url,
    option,
    payload,
    onBeginCallback,
    onFinallyCallback
  ) => {
    try {
      _guardCallback(onBeginCallback);
      const response = await axios.put(url, payload, option);
      return response.data;
    } catch (error) {
      return _onError(error);
    } finally {
      _guardCallback(onFinallyCallback);
    }
  }
};

export { syncApi, asyncApi };



// WEBPACK FOOTER //
// ./src/services/apiService.js